import React, { ReactNode, useMemo } from "react";
import { createReactErrorReporter } from "../../utils/errorReporter";
import ErrorTemplate from "../atoms/ErrorTemplate";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

const FunctionalErrorBoundary: React.FC<Props> = ({ children }) => {
  const reportError = useMemo(() => createReactErrorReporter(), []);

  return (
    <ErrorBoundaryInner onError={reportError}>{children}</ErrorBoundaryInner>
  );
};

class ErrorBoundaryInner extends React.Component<
  {
    children?: ReactNode;
    onError: (error: Error, errorInfo: React.ErrorInfo) => void;
  },
  State
> {
  public state: State = { hasError: false };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.props.onError(error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorTemplate errorType="temporary" />;
    }
    return this.props.children;
  }
}

export default FunctionalErrorBoundary;
